import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Páginas
import Home from './pages/Home';
import Login from './pages/Login';
import ComoLlegar from './pages/ComoLlegar';
import DashboardCancha from './pages/DashboardCancha';
import DashboardAdmin from './pages/DashboardAdmin';
import Diagnostico from './pages/Diagnostico';

// Componente para rutas protegidas
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { usuario, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Cargando...</div>
      </div>
    );
  }

  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(usuario.rol)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/como-llegar" element={<ComoLlegar />} />
          <Route path="/diagnostico" element={<Diagnostico />} />
  
          <Route
            path="/cancha"
            element={
              <ProtectedRoute allowedRoles={['cancha', 'admin']}>
                <DashboardCancha />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <DashboardAdmin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
